import GGVarImpact from './GGVarImpact';
export default GGVarImpact;
